// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select.select {
  margin: 0px;
}

.row {
  align-items: center;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.red {
  color: #d3001d;
}

.globalLimit {
  padding-bottom: 10px;
}

.spendDailyDelete, .spendDailyRolloverPeriod, .spendDailyRemoved, .spendDailyAmountUsed, .spendDailyNewLimitEffective {
  display: none;
}

.spendWeeklyDelete, .spendWeeklyRolloverPeriod, .spendWeeklyRemoved, .spendWeeklyAmountUsed, .spendWeeklyNewLimitEffective {
  display: none;
}

.spendMonthlyDelete, .spendMonthlyRolloverPeriod, .spendMonthlyRemoved, .spendMonthlyAmountUsed, .spendMonthlyNewLimitEffective {
  display: none;
}

.input {
  display: inline-block;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label-colum {
  display: flex;
  align-items: center;
}

.button-row {
  justify-content: center;
  display: grid;
}

.label-text {
  text-overflow: "-";
  white-space: nowrap;
}

hr {
  border: 0;
  height: 1px;
  background: #C2C2C2;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/limits/spend-limit/spend-limit.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;;AAGI;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAAR;;AAGI;EACI,cAAA;AAAR;;AAGI;EACI,oBAAA;AAAR;;AAGI;EACI,aAAA;AAAR;;AAGI;EACI,aAAA;AAAR;;AAGI;EACI,aAAA;AAAR;;AAGI;EACI,qBAAA;AAAR;;AAGI;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAR;;AAGI;EACI,aAAA;EACA,mBAAA;AAAR;;AAGI;EACI,uBAAA;EACA,aAAA;AAAR;;AAII;EACI,kBAAA;EACA,mBAAA;AADR;;AAII;EACI,SAAA;EACA,WAAA;EACA,mBAAA;AADR","sourcesContent":["\r\n    ion-select.select {\r\n        margin: 0px;\r\n    }\r\n    \r\n    .row {\r\n        align-items: center;\r\n        white-space: nowrap;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .red {\r\n        color: #d3001d;\r\n    }\r\n\r\n    .globalLimit {\r\n        padding-bottom: 10px;\r\n    }\r\n\r\n    .spendDailyDelete, .spendDailyRolloverPeriod, .spendDailyRemoved, .spendDailyAmountUsed, .spendDailyNewLimitEffective {\r\n        display: none;\r\n    }\r\n\r\n    .spendWeeklyDelete, .spendWeeklyRolloverPeriod, .spendWeeklyRemoved, .spendWeeklyAmountUsed, .spendWeeklyNewLimitEffective  {\r\n        display: none;\r\n    }\r\n\r\n    .spendMonthlyDelete, .spendMonthlyRolloverPeriod, .spendMonthlyRemoved, .spendMonthlyAmountUsed, .spendMonthlyNewLimitEffective {\r\n        display: none;\r\n    }\r\n\r\n    .input {\r\n        display: inline-block;\r\n    }\r\n\r\n    .deposit-column {\r\n        flex-direction: row;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n\r\n    .label-colum {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    \r\n    .button-row {\r\n        justify-content: center;\r\n        display: grid;\r\n        \r\n    }\r\n\r\n    .label-text {\r\n        text-overflow: \"-\";\r\n        white-space: nowrap;\r\n    }\r\n\r\n    hr {\r\n        border: 0;\r\n        height: 1px;\r\n        background: #C2C2C2;\r\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
